import { parse } from 'date-fns'

export function parseDate(dateString: string | Date): Date {
  return parse(String(dateString), 'dd-MM-yyyy HH:mm:ss', new Date())
}
